export const AUTH_PROVIDERS_TITLE = 'auth-providers.title';
